import React from "react";

interface OverviewLayoutProps {
  children: React.ReactNode;
  rightSidebar?: React.ReactNode;
}

const OverviewLayout: React.FC<OverviewLayoutProps> = ({ children, rightSidebar }) => {
  return (
    <div className="flex flex-col md:flex-row gap-6 w-full">
      {/* Main Content */}
      <main className={`flex-1 ${rightSidebar ? 'max-w-3xl w-full mx-auto md:mx-0' : 'w-full'} `}>
        {children}
      </main>
      {/* Right Sidebar */}
      {rightSidebar && (
        <aside className="w-full md:w-80 flex-shrink-0">
          {rightSidebar}
        </aside>
      )}
    </div>
  );
};

export default OverviewLayout; 